export default "__VITE_ASSET__08d3cabb__"